import React from 'react';
import ProductTile from './ProductTile';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';

const ProductTileWithClickTracking = WithClickTracking(ProductTile);

const ProductTileContainer = ({ products, onResultClick, onAddToCartClick }) =>
    <div className="product-list">
        <div className="row">
            {products.map((product, i) => {
                return (
                    <div key={i} className="col-sm-6 col-lg-4 mb-4">
                        <ProductTileWithClickTracking 
                            defaultVariationSku={product.DefaultVariationSku}
                            name={!!product.DefaultVariationName ? product.DefaultVariationName : product.ProductName}
                            status={product.DefaultVariationStatus}
                            url={product.Url}
                            priceViewModel={product.PriceViewModel}
                            image={product.Image}
                            HitId={product.HitId}
                            canAddToCart={product.CanAddToCart}
                            onResultClick={onResultClick}
                            onAddToCartClick={onAddToCartClick}
                            isUserLoggedIn={product.IsUserLoggedIn}
                            loginLink={product.LoginLink}
                            description={product.Description}
                            sku={product.SKU}
                            contactUsLink={product.ContactUsLink}
                            showStatus={product.ShowStatus}
                        />
                    </div>
                );
            })}
        </div>
    </div>;

ProductTileContainer.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        DefaultVariationSku: PropTypes.string,
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        onAddToCartClick: PropTypes.func,
        Description: PropTypes.string,
        CanAddToCart: PropTypes.bool,
        IsUserLoggedIn: PropTypes.bool,
        LoginLink: PropTypes.string
    }))
};

export default ProductTileContainer;